import { render, staticRenderFns } from "./NpsmEditMain.vue?vue&type=template&id=0b954c2a&scoped=true&"
import script from "./NpsmEditMain.vue?vue&type=script&lang=js&"
export * from "./NpsmEditMain.vue?vue&type=script&lang=js&"
import style0 from "./NpsmEditMain.vue?vue&type=style&index=0&id=0b954c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b954c2a",
  null
  
)

export default component.exports